import type { InternalUrl } from '@tbitop/routing';
import { toInternalUrl } from '@tbitop/routing';

export const toLocationDescriptor = (url: string | InternalUrl) => {
  const { pathname, query } = toInternalUrl(url);
  return {
    pathname,
    search: `?${new URLSearchParams(query).toString()}`,
  };
};
